import { Component } from '@angular/core';

@Component({
    selector: 'hyd-empty',
    template: ''
})
export class CUIEmptyComponent {
    constructor() { }    
}


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-empty/cui-empty.component.ts